export enum QUERY_KEYS {
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
}

export default QUERY_KEYS
